import { ReactComponent as LeftArrow } from "../../../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../../../assets/icons/rightArrow.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowLeft.svg";
import { ReactComponent as File } from "../../../../assets/icons/file.svg";
import { ReactComponent as SelectIcon } from "../../../../../common/assets/icons/selectIcon.svg";

import Input from "../../../../components/common/input";
import OBDetailTable from "./OBDetailTable";
import OBInfo from "./OBInfo";
import React, { useEffect, useState } from "react";
import { useGetOtherBranchCustomerList } from "../../../../../common/hooks/console/otherBranch/useGetOtherBranchCustomer";
import { useGetOtherBranchCustomerCount } from "../../../../../common/hooks/console/otherBranch/useGetOtherBranchCustomerCount";
import { useGetOtherBranchInfo } from "../../../../../common/hooks/console/otherBranch/useGetOtherBranchInfo";
import { useNavigate } from "react-router-dom";
import { useGetOBDeliveryDate } from "../../../../../common/hooks/console/otherBranch/useGetOtherBranchDate";
import { useOpenedWindowsStore } from "../../../../store/useOpenedWindowsStore";
import Button from "../../../../../common/components/button";
import Excel from "../../../../components/common/excel";

type OBDetailProps = {
    showOBDetail: () => void;
    customerIdx?: number;
    customer: string;
};

const OBDetail = ({ showOBDetail, customerIdx = 0, customer }: OBDetailProps) => {
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [field, setField] = useState<string>("delivery_date");
    const [direction, setDirection] = useState<"ASC" | "DESC">("DESC");
    const [startDate, setStartDate] = useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [status, setStatus] = useState<number[]>([]);
    const [excelClick, setExcelClick] = useState(false);

    const handleDateChange = (start?: Date, end?: Date) => {
        if (start) setStartDate(start);
        if (end) setEndDate(end);
    };
    const { data: deliveryDateData } = useGetOBDeliveryDate({
        customerIdx,
        payment_status: status.length === 1 ? status[0] : undefined,
    });
    const { data: listData } = useGetOtherBranchCustomerList(customerIdx, {
        page: currentPage,
        searchtxt: searchTxt,
        field: field,
        direction: direction,
        startDate: startDate,
        endDate: endDate,
        status:
            status.length === 2 && status.includes(1) && status.includes(2)
                ? 0
                : status.length === 1 && status.includes(1)
                  ? 1
                  : status.length === 1 && status.includes(2)
                    ? 2
                    : 0,
    });

    const { data: countData } = useGetOtherBranchCustomerCount(customerIdx, startDate, endDate);
    const { data: infoData } = useGetOtherBranchInfo(customerIdx, startDate, endDate);

    const handleStatusToggle = (value: number) => {
        setStatus(prevStatus => (prevStatus.includes(value) ? [] : [value]));
        setCurrentPage(1);
        setInputValue("1");
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setInputValue(page.toString());
    };

    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (listData?.last_page || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        handlePageChange(pageNumber);
    };

    const handleSort = (newField: string) => {
        setField(prevField => {
            if (prevField === newField) {
                setDirection(prevDirection => (prevDirection === "DESC" ? "ASC" : "DESC"));
                return prevField;
            } else {
                setDirection("ASC");
                return newField;
            }
        });
    };

    const handleNavigate = () => {
        const { openWindow } = useOpenedWindowsStore.getState();

        if (customerIdx) {
            const path = "/console/settings";
            const id = "settings";

            localStorage.setItem("customer_idx", customerIdx.toString());
            localStorage.setItem("code", "other");

            openWindow(id, path);
        }
    };

    useEffect(() => {
        setStartDate(deliveryDateData?.oldest_delivery_date ? new Date(deliveryDateData.oldest_delivery_date) : undefined);
        setEndDate(deliveryDateData?.latest_delivery_date ? new Date(deliveryDateData.latest_delivery_date) : undefined);
    }, [deliveryDateData]);

    return (
        <div className="flex w-full">
            <div className="flex-1 h-full flex flex-col overflow-hidden">
                {/* Header */}
                <div className="flex justify-between p-3 items-center border-b border-gray4">
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => {
                                navigate("/console/other-branch");
                            }}
                            className="border border-gray4 mr-2 rounded-lg w-[34px] h-[34px] flex items-center justify-center"
                        >
                            <ArrowLeft />
                        </button>
                        <p className="text-2xl">{infoData?.customer_name}</p>
                        <File />
                        <button onClick={handleNavigate} className="text-sm underline">
                            고객 관리
                        </button>
                    </div>
                    <div className="flex items-center gap-2">
                        <button onClick={() => currentPage && currentPage > 1 && handlePageChange(currentPage - 1)}>
                            <LeftArrow />
                        </button>
                        <Input
                            inputClassName="text-center"
                            className="w-20 text-center outline-0 text-sm flex"
                            value={inputValue}
                            onChange={e => handlePageInput(e.target.value)}
                        />
                        <p className="text-gray3">/ {listData?.last_page}</p>
                        <button
                            onClick={() => currentPage && currentPage < (listData?.last_page || 1) && handlePageChange(currentPage + 1)}
                        >
                            <RightArrow />
                        </button>
                    </div>
                </div>
                {/* Title */}
                <div className=" p-3 text-sm items-center border-b border-gray4 xl:flex">
                    <p className="font-bold mr-4 w-56">
                        {startDate ? startDate.toLocaleDateString() : "날짜 선택"} ~ {endDate ? endDate.toLocaleDateString() : "날짜 선택"}
                    </p>
                    <div className="mt-2 xl:mt-0 flex gap-4 items-center w-full">
                        <div className="flex items-center gap-1">
                            <p className="text-xs">누적 발주건수</p>
                            <p className="text-sm font-bold text-primary2">{countData?.total_order_count.toLocaleString()} 건</p>
                        </div>
                        <div className="flex items-center gap-1">
                            <p className="text-xs">누적 발주금액</p>
                            <p className="font-bold text-primary2">{countData?.total_order_amount.toLocaleString()} 원</p>
                        </div>
                        <div className="w-1 h-1 rounded-full bg-gray4" />

                        <div className="flex gap-1 items-center">
                            <p className="text-sm font-bold mr-2">정산완료</p>
                            <p className="text-xs">총</p>
                            <button
                                className={`text-sm text-skyblue underline ${status.includes(2) ? "font-bold" : ""}`}
                                onClick={() => handleStatusToggle(2)}
                            >
                                {countData?.payment_complete_count.toLocaleString()} 건
                            </button>
                        </div>
                        <div className="w-1 h-1 rounded-full bg-gray4" />
                        <div className="flex gap-1 items-center">
                            <p className="text-sm font-bold mr-2">미정산</p>
                            <p className="text-xs">총</p>
                            <button
                                className={`text-sm text-error underline ${status.includes(1) ? "font-bold" : ""}`}
                                onClick={() => handleStatusToggle(1)}
                            >
                                {countData?.pending_count.toLocaleString()} 건
                            </button>
                        </div>
                        <div className={`${customer === "개인 회원" ? "ml-1" : " ml-auto"}`}>
                            <Button
                                onClick={() => {
                                    setExcelClick(true);
                                }}
                                size="S"
                                className="px-2"
                                icon={<SelectIcon className={`${excelClick ? "rotate-180" : ""}`} />}
                                iconPosition="right"
                            >
                                타지점 발주
                            </Button>
                            {excelClick && (
                                <Excel
                                    initialDownloadClick="branch"
                                    customer_idx={customerIdx}
                                    startDate={startDate}
                                    endDate={endDate}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                    onDateSubmit={(start, end) => {
                                        setStartDate(start ? new Date(start) : undefined);
                                        setEndDate(end ? new Date(end) : undefined);
                                    }}
                                    branch={infoData?.customer_name}
                                    onClose={() => setExcelClick(false)}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="overflow-y-auto">
                    <OBDetailTable customerIdx={customerIdx} onSort={handleSort} data={listData?.data_list} />
                </div>
            </div>
            <div className="md:min-w-[620px] min-w-[560px] overflow-y-auto bg-gray6 p-4 h-dvh">
                <OBInfo
                    customerIdx={customerIdx}
                    startDate={startDate}
                    endDate={endDate}
                    onDateChange={handleDateChange}
                    pendingAmount={infoData?.pending_amount}
                />
            </div>
        </div>
    );
};

export default OBDetail;
